import React, { useEffect, useState } from "react";
import "./kpiPreview.css";
import CardPreview from "./Components/CardPreview/CardPreview";
import TagPreview from "./Components/TagPreview/TagPreview";
import ToggleButtons from "./Components/ToggleButtons/ToggleButtons";
import SummaryCards from "./Components/SummaryCards/SummaryCards";
interface KPIPreviewProps {
  kpi: any;
  defaultConfigGlobal: Record<string, any>;
}
const KPIPreview: React.FC<KPIPreviewProps> = ({ kpi, defaultConfigGlobal }) => {
  const [activeTab, setActiveTab] = useState<string>("CardPreview");
  const showToggleButtons = kpi.buttons?.length > 0 ? true : false;
  const renderContent = () => {
    switch (activeTab) {
      case "CardPreview":
        return <CardPreview kpi={kpi} />;
      case "TagPreview":
        return <TagPreview kpi={kpi} defaultConfigGlobal={defaultConfigGlobal} />;
      case "ToggleButtons":
        return <ToggleButtons kpi={kpi}
          defaultConfigGlobal={defaultConfigGlobal}
        />;
      case "SummaryCards":
        return <SummaryCards kpi={kpi}
          defaultConfigGlobal={defaultConfigGlobal}
        />;
      default:
        return <CardPreview kpi={kpi} />;
    }
  };
  useEffect(() => {
    if (!showToggleButtons && activeTab === "ToggleButtons")
      setActiveTab("CardPreview");
  }, [kpi.buttons]);

  return (
    <div className="kpi-preview-tab-menu-container">
      <div className="kpi-preview-tab-menu">
        <button
          className={`kpi-preview-tab-button ${activeTab === "CardPreview" ? "active" : ""
            }`}
          onClick={() => setActiveTab("CardPreview")}
        >
          Card preview
        </button>
        <button
          className={`kpi-preview-tab-button ${activeTab === "TagPreview" ? "active" : ""}`}
          onClick={() => setActiveTab("TagPreview")}
        >
          Tag preview
        </button>
        {showToggleButtons && (
          <button
            className={`kpi-preview-tab-button ${activeTab === "ToggleButtons" ? "active" : ""
              }`}
            onClick={() => setActiveTab("ToggleButtons")}
          >
            Toggle buttons
          </button>
        )}
        <button
          className={`kpi-preview-tab-button ${activeTab === "SummaryCards" ? "active" : ""
            }`}
          onClick={() => setActiveTab("SummaryCards")}
        >
          Summary cards
        </button>
      </div>
      <div className="kpi-preview-content">{renderContent()}</div>
    </div>
  );
};

export default KPIPreview;
